"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgSmartwatch(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { x: 9, y: 9, width: 22, height: 22, rx: 4, stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 22a2 2 0 100-4 2 2 0 000 4z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M31 13h2a1 1 0 011 1v2a1 1 0 01-1 1h-2v-4z", fill: "currentColor", stroke: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M13 4a2 2 0 012-2h10a2 2 0 012 2v5H13V4zM13 31h14v5a2 2 0 01-2 2H15a2 2 0 01-2-2v-5z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 13v7M20 20l3.5 5.5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgSmartwatch;
//# sourceMappingURL=Smartwatch.js.map